////
/// ============================================================================
/// COMPONENT / Switch
/// ============================================================================
///
/// @group components
////

export default () => {

    document.querySelectorAll('.c-switch').forEach(function (element) {
        let input = element.querySelector('input');

        if (input) {
            input.addEventListener('change', function () {
                element.classList.toggle('-checked', input.checked);
            });

            element.classList.toggle('-checked', input.checked);
        }
    });

};
